// Libraries
import { useQuery } from "@tanstack/react-query";

// Services
import { getMakes } from "@/Common/api/vehicles";
import { getModels, getModelTrims, getModelYears } from "@/Common/api/vehicles/queries";

// Constants
import { CRM_KEYS } from "../../../constants";

export default function useVehicleOptions(make: string = "", model: string = "", needTrim: boolean = false) {
	const { data: makeOptions = [], isLoading: isLoadingMakeOptions } = useQuery({
		queryKey: [CRM_KEYS.QUERY.VEHICLE_OPTIONS, "Make"],
		queryFn: async () => {
			const makes = await getMakes();
			return makes.map((item: { make: string }) => ({ type: item.make }));
		},
	});

	const { data: modelOptions = [], isLoading: isLoadingModelOptions } = useQuery({
		queryKey: [CRM_KEYS.QUERY.VEHICLE_OPTIONS, "Model", make || ""],
		queryFn: async () => {
			//@ts-ignore
			const model = await getModels(make);
			return model.map((item: { model: string }) => ({ type: item.model }));
		},
		enabled: !!make,
	});

	const { data: trimOptions = [], isLoading: isLoadingTrimOptions } = useQuery({
		queryKey: [CRM_KEYS.QUERY.VEHICLE_OPTIONS, "Trim", make, model],
		queryFn: async () => {
			const trims = await getModelTrims(make, model);
			return trims.map(({ trim }: { trim: string }) => ({ type: trim }));
		},
		enabled: !!make && !!model && needTrim,
	});

	const { data: yearOptions = [], isLoading: isLoadingYearsOptions } = useQuery({
		queryKey: [CRM_KEYS.QUERY.VEHICLE_OPTIONS, "Year", make, model],
		queryFn: async () => {
			const years = await getModelYears(make, model);
			return years.map(({ year }: { year: number }) => ({ type: String(year) }));
		},
		enabled: !!make && !!model,
	});

	return {
		make: { data: makeOptions, isLoading: isLoadingMakeOptions },
		model: { data: modelOptions, isLoading: isLoadingModelOptions },
		trim: { data: trimOptions, isLoading: isLoadingTrimOptions },
		year: { data: yearOptions, isLoading: isLoadingYearsOptions },
	};
}
